<template>
  <div class="commonDetail">
    <div class="lawTitle">同族专利信息</div>
    <!-- <Table :tableColumns="kindredsInfoColumns"
          :tableData="kindredsInfoTableData"
          :isRowSelection="false"
          :isShowPageSize="false"></Table>
    <div class="lawTitle">专利优先权</div>
    <Table :tableColumns="priorityInfoColumns"
          :tableData="priorityInfoTableData"
          :isRowSelection="false"
          :isShowPageSize="false"></Table>
    <div class="lawTitle">引证信息</div>
          <Table :tableColumns="citingInfoColumns"
          :tableData="citingInfoTableData"
          :isRowSelection="false"
          :isShowPageSize="false"></Table> -->
  </div>
</template>

<script>
// import { kindredPatent } from '@/api/classification'
// import Table from '@/components/table'
// import { menuOptions } from '../config'

export default {
  props: {
    detailList: Object
  },
  data() {
    return {
      // kindredsInfoColumns: menuOptions.kindredsInfoColumns,
      // kindredsInfoTableData: [],
      // citingInfoTableData: [],
      // citingInfoColumns: menuOptions.citingInfoColumns,
      // priorityInfoColumns: menuOptions.priorityInfoColumns,
      // priorityInfoTableData: []
    }
  },
  components: {
    // Table
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // kindredPatent(this.detailList.id).then((res) => {
      //   if (res.data.code === 200) {
      //     if (res.data.data.citingInfo !== null) {
      //       res.data.data.citingInfo.key = 1
      //       this.citingInfoTableData.push(res.data.data.citingInfo)
      //     }

      //     this.kindredsInfoTableData = res.data.data.kindredsInfo
      //     this.kindredsInfoTableData.forEach((item, index) => {
      //       item.key = index + 1
      //     })
      //     if (res.data.data.priorityInfo !== null) {
      //       res.data.data.priorityInfo.key = 1
      //       this.priorityInfoTableData.push(res.data.data.priorityInfo)
      //     }
      //   }
      // })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
